import { create } from 'zustand';
import type { AuthStore } from '@fleek-platform/login-button';
import { persist, createJSONStorage } from 'zustand/middleware';

type UserProfile = {
  username?: string;
  avatar?: string;
};

interface UserStore {
  authStoreInstance?: AuthStore;
  userProfile?: UserProfile;

  setAuthStoreInstance: (authStore: AuthStore) => void;
  triggerLogin: () => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    (set, get) => ({
      authStoreInstance: {} as AuthStore,
      setAuthStoreInstance: (authStore) => {
        const updatedState: {
          authStoreInstance?: AuthStore;
          userProfile?: UserProfile;
        } = { authStoreInstance: authStore };

        if (authStore.userProfile?.username || authStore.userProfile?.avatar) {
          updatedState.userProfile = {
            username: authStore.userProfile?.username,
            avatar: authStore.userProfile?.avatar,
          };
        }

        set(updatedState);
      },
      triggerLogin: () => {
        const { authStoreInstance } = get();
        const triggerLoginModal = authStoreInstance?.triggerLoginModal;

        try {
          if (typeof triggerLoginModal !== 'function') {
            console.warn(
              `Expected triggerLoginModal to be a ready function but got ${typeof triggerLoginModal}. If this issue persists, please contact support at https://fleek.xyz/support`,
            );

            return;
          }

          triggerLoginModal(true);
        } catch (err) {
          console.error('Failed to trigger login modal', err);
        }
      },
    }),
    {
      name: 'user-profile-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ userProfile: state.userProfile }),
    },
  ),
);
